import React, { useEffect, useState } from 'react'
import axios from 'axios'

export const Header = () => {
    const gameData = {
        // path: 'starbites',
        // path:'reynatis'
        path: 'r-type-tactics',
        //  path:'horizon'
    }

    const [releaseDateNA, setReleaseDateNA] = useState('Coming June 18, 2026')

    const formatReleaseDate = (dateStr) => {
        const datePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/
        if (!datePattern.test(dateStr)) {
            return dateStr
        }

        try {
            const now = new Date()
            const nowPT = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }))

            const [month, day, year] = dateStr.split('/').map(Number)
            const releaseDatePT = new Date(Date.UTC(year, month - 1, day, 13, 0, 0))

            return nowPT >= releaseDatePT ? 'Available Now' : 'Coming June 18, 2026'
        } catch (e) {
            console.error('Date parse error:', e)
            return dateStr
        }
    }

    useEffect(() => {
        let timerId
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://www.nisamerica.com/api/game/${gameData.path}`)

                // const naDateStr = response.data.game.releases.NA?.['Nintendo Switch™']

                setReleaseDateNA(formatReleaseDate('Coming June 18, 2026'))
            } catch (error) {
                console.error(error)
            }
        }

        fetchData()

        timerId = setInterval(fetchData, 60 * 1000)

        return () => clearInterval(timerId)
    }, [gameData.path])

    return (
        <div className=''>
            <div className='bg-main md:flex justify-center items-center flex-row-reverse relative'>
                <div className='absolute bottom-0 lg:top-1/2 lg:right-0 lg:-translate-y-1/2 lg:w-1/2'>
                    <img
                        className=' mx-auto'
                        // height='246'
                        // width='1000'
                        src={`${process.env.PUBLIC_URL}/assets/rtype-logo.png`}
                        alt='logo'
                    />
                    <h1 className='release uppercase text-rttcgreen font-black text-center text-md md:text-lg italic py-4 tracking-widest'>
                        {releaseDateNA}
                    </h1>
                    <button className='relative mx-auto flex md:mt-8'>
                        <a href='#products'>
                            <img
                                className=' max-w-[400px]'
                                // height='246'
                                // width='1000'
                                src={`${process.env.PUBLIC_URL}/assets/order-button.webp`}
                                alt='logo'
                            />
                            <p className='w-full absolute text-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-base sm:text-sm md:text-md font-bold text-white uppercase '>
                            {releaseDateNA==='Available Now'?'Buy Now':'Preorder'}
                            </p>{' '}
                        </a>
                    </button>
                </div>
            </div>
        </div>
    )
}
